import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="main">
      {/* Header start */}
      <header id="header">
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-3 col-md-4 col-8 p-0">
              <div className="navbar-header" style={{paddingLeft: '0'}}>
                <Link className="navbar-brand" to="/">
                  <img alt="dptech" src="images/dptech_logo_white.png" style={{height: '60px'}} />
                </Link> 
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-4 p-0">
              <button data-target=".navbar-collapse" data-toggle="collapse" className="navbar-toggle d-block d-lg-none d-xl-none" type="button">
                <i className="fa fa-bars"></i>
              </button>
              <div className="overlay"></div>
              <div id="menu" className="navbar-collapse collapse">
                <ul className="nav navbar-nav">
                  <li className="level">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="level">
                    <Link to="/#data-solutions-part">Data solutions</Link>
                  </li>
                  <li className="level">
                    <Link to="/#cloud-part">Cloud</Link>
                  </li>
                  <li className="level">
                    <Link to="/#use-cases-part">Use case</Link>
                  </li>
                  <li className="level">
                    <Link to="/about" className="active">About</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Header end */}

      {/* Navbar Background Space */}
      <div className="navbar-background-space" style={{background: '#1a1a1a', height: '140px'}}></div>

      {/* About Content */}
      <section style={{padding: '30px 0 40px 0', background: '#fff'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="about-content" style={{lineHeight: '1.8', color: '#333'}}>
                


                {/* Full Width Contact Form */}
                <div className="contact-form-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '28px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px', textAlign: 'center'}}>Collabora con noi</h2>
                  <p style={{color: '#666', marginBottom: '25px', fontSize: '16px', textAlign: 'center'}}>Raccontaci il tuo progetto e scopri come possiamo aiutarti</p>
                  
                  <div className="contact-form-container" style={{background: '#f8f9fa', padding: '30px', borderRadius: '8px', border: '1px solid #e9ecef'}}>
                    <form
                      action="https://formspree.io/f/mblknoly"
                      method="POST"
                      style={{display: 'flex', flexDirection: 'column', gap: '20px'}}
                    >
                      <div className="form-group">
                        <label htmlFor="email" style={{display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500'}}>La tua email *</label>
                        <input 
                          type="email" 
                          id="email" 
                          name="email" 
                          required
                          style={{
                            width: '100%', 
                            padding: '12px', 
                            background: '#fff', 
                            border: '1px solid #ddd', 
                            color: '#333', 
                            borderRadius: '4px', 
                            fontSize: '14px'
                          }} 
                        />
                      </div>
                      
                      <div className="form-group">
                        <label htmlFor="message" style={{display: 'block', marginBottom: '8px', color: '#333', fontWeight: '500'}}>Descrivi il tuo progetto *</label>
                        <textarea 
                          id="message" 
                          name="message" 
                          required 
                          rows="4"
                          placeholder="Raccontaci del tuo progetto e delle tue esigenze"
                          style={{
                            width: '100%', 
                            padding: '12px', 
                            background: '#fff', 
                            border: '1px solid #ddd', 
                            color: '#333', 
                            borderRadius: '4px', 
                            fontSize: '14px', 
                            resize: 'vertical'
                          }}
                        ></textarea>
                      </div>
                      
                      <button 
                        type="submit" 
                        className="btn big-width btn-color" 
                        style={{
                          fontSize: '16px', 
                          fontWeight: '500', 
                          fontFamily: "'Poppins', sans-serif",
                          alignSelf: 'flex-start'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.background = '#FF5DA2';
                          e.currentTarget.style.color = '#fff';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.background = '#FFD84D';
                          e.currentTarget.style.color = '#090909';
                        }}
                      >
                        <b>Invia Messaggio</b>
                      </button>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer section start */}
      <footer style={{background: '#f8f9fa', color: '#555', padding: '60px 0 20px 0', marginTop: 0}}>
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <img src="images/dpTech_logo_1916x710_300dpi_RGB_transparent.png" alt="dpTech" style={{height: '40px', marginBottom: '15px'}} />
                <p style={{color: '#555', lineHeight: '1.5', marginBottom: '15px', fontSize: '14px'}}>
                  dpTech è il tuo partner per l'innovazione. Trasformiamo i dati in valore per il tuo business.
                </p>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Servizi</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#data-solutions-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Data Solutions</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#cloud-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cloud</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#use-cases-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Use Cases</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Chi Siamo</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Legal & Contact */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Informazioni</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/privacy" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Privacy Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/cookies" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cookies Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Contattaci</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Contact Info */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Contatti</h5>
                <div style={{color: '#555', lineHeight: '1.5'}}>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-envelope" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    info@dptech.io
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-map-marker-alt" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    Milano, Italia
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <a href="https://www.linkedin.com/company/dptech-io" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease'}}>
                      <i className="fab fa-linkedin" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                      LinkedIn
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Footer Bottom */}
          <div className="footer-bottom" style={{borderTop: '1px solid #dee2e6', paddingTop: '20px', marginTop: '20px'}}>
            <div className="row align-items-center">
              <div className="col-6 text-left">
                <p style={{color: '#555', margin: 0, fontSize: '13px', lineHeight: '1.4'}}>
                  © 2025 dpTech | Data Solutions. Tutti i diritti riservati.<br />
                  P.IVA: 14159740969
                </p>
              </div>
              <div className="col-6 text-right">
                <div style={{color: '#555', fontSize: '11px', lineHeight: '1.3'}}>
                  <p style={{margin: 0, fontStyle: 'italic', fontFamily: "'Poppins', sans-serif"}}>
                    dptech.io si impegna a seguire le linee guida WCAG 2.1 AA, e a rendere il proprio sito web accessibile.{' '}
                    <a href="/files/Dichiarazione di accessibilita.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'underline'}}>Dichiarazione di accessibilità</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Footer section end */}
    </div>
  );
}

export default About;
